import { useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { YourTeam } from '../../components/agents/YourTeam';

/** The workspace's agents, for a tenant admin: the core ones, and the specialists to recruit, dismiss or give work. */
export function TeamTab() {
  const navigate = useNavigate();

  return (
    <Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Every workspace has the core agents. Specialists you recruit take jobs from you and steps from your Chief of Staff’s plans.
      </Typography>
      <YourTeam onOpenRun={(runId) => navigate(`/activity?run=${encodeURIComponent(runId)}`)} />
    </Box>
  );
}
